import React, { useState } from "react"
import styled, { css, keyframes } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Risa from "../../images/risa.webp"
import theme from "../../theme"
import TitleImg from "../../images/arktitle.png"
import VideoModal from "../video-modal"
import PlayIcon from "../../images/Play_Button.png"
import PlayIconBG from "../../images/Play_Circle_BG.png"
import EarlyAccessImg from "../../images/Early_Access.png"
import { Container } from "../global"

const StyledHero = styled.section`
  height: calc(100vh);
  position: relative;
  overflow: hidden;
  min-height: 600px;
`

const StyledBG = styled(Img)`
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
`

const RisaImg = styled.img`
  position: absolute;
  bottom: 0;
  left: 0rem;
  object-fit: contain;
  object-position: center bottom;
  max-width: 100vw;
  height: 100%;
  max-height: 80vh;
  pointer-events: none;
  user-select: none;
  @media only screen and (max-width: ${theme.breakpoints.lg}) {
    left: -6rem;
  }
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    left: -4rem;
  }
`

const Title = styled.img`
  max-width: 100%;
  width: 750px;
  user-select: none;
  pointer-events: none;
`

const ContentBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 1rem;
`

const RightBox = styled.div`
  margin-left: auto;
  padding-top: 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  @media only screen and (max-width: ${theme.breakpoints.lg}) {
    padding-top: 100px;
  }
`

const EarlyAccessButtonLink = styled.a`
  margin-top: 9rem;
  z-index: 2;
`

const EarlyAccessButton = styled.img`
  width: 300px;
  max-width: 100%;
  @media only screen and (max-width: ${theme.breakpoints.lg}) {
    width: 225px;
    bottom: 1.5rem;
    right: 50%;
    transform: translateX(50%);
    position: absolute;
  }
`

const LeftBox = styled.div``

const ModalPlayButton = styled.button`
  margin-top: 6rem;
  background: none !important;
  border: none;
  padding: 0 !important;
  position: relative;
  cursor: pointer;
  user-select: none;
  transition: 0.27s ease;
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    margin-top: 1rem;
    transform: scale(0.6);
  }
  &:hover {
    transform: scale(1.05);
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      transform: scale(0.625);
    }
  }
`

const rotateKeyFrames = keyframes`
  0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
  }
`

export const rotateAnim = (length) => css`
  animation: ${rotateKeyFrames} ${length} infinite;
`

const ModalPlayButtonBG = styled.img`
  position: absolute;
  animation: ${rotateKeyFrames} 30s infinite;
  transform: rotate(40);
`

const ModalPlayIcon = styled.img``

const Hero = () => {
  const data = useStaticQuery(graphql`
    query {
      bg: file(relativePath: { eq: "herobg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      title: file(relativePath: { eq: "title.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  const [videoOpen, setVideoOpen] = useState(false)
  const handleClickPlayButton = () => {
    setVideoOpen(true)
  }

  return (
    <>
      <VideoModal
        videoId="ETF8QYvWaPM"
        isOpen={videoOpen}
        onClose={() => setVideoOpen(false)}
      />
      <StyledHero id="Hero">
        <StyledBG fluid={data.bg.childImageSharp.fluid} alt="hero-background" />
        <ContentBox>
          <Container>
            <LeftBox>
              <RisaImg src={Risa} alt="risa-featured-image" />
            </LeftBox>
            <RightBox>
              <Title src={TitleImg} alt="title-ark" />
              <ModalPlayButton onClick={() => handleClickPlayButton()}>
                <ModalPlayButtonBG src={PlayIconBG}></ModalPlayButtonBG>
                <ModalPlayIcon src={PlayIcon} alt="Play Icon"></ModalPlayIcon>
              </ModalPlayButton>
              <EarlyAccessButtonLink
                href="https://www.patreon.com/projectarkgame"
                target="_blank"
              >
                <EarlyAccessButton
                  src={EarlyAccessImg}
                  alt="Get Early Access"
                />
              </EarlyAccessButtonLink>
            </RightBox>
          </Container>
        </ContentBox>
      </StyledHero>
    </>
  )
}

export default Hero
